import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useRouteOrgSynced } from './useRouteOrgSynced';


type OrgScopedRouteGuardProps = {
  children: React.ReactNode;
  paramName?: string;
};

export const OrgScopedRouteGuard: React.FC<OrgScopedRouteGuardProps> = ({
  children,
  paramName = 'organization_id',
}) => {
  const { params } = useRouteMatch<Record<string, string>>();
  const routeOrg = params[paramName];

  const { ready, isLoading, isUnknownRouteOrg } = useRouteOrgSynced({
    routeOrg,
  });

  if (!routeOrg || isLoading || isUnknownRouteOrg || !ready) {
    return null;
  }

  return <>{children}</>;
};

type CreateOrgScopedRouteOptions<P> = {
  pageProps?: P;
  paramName?: string;
};

export const createOrgScopedRoute = <P extends object = Record<string, never>>(
  Page: React.ComponentType<P>,
  options?: CreateOrgScopedRouteOptions<P>
) => {
  const { pageProps, paramName } = options ?? {};
  const props = (pageProps ?? {}) as P;

  const OrgScopedRoute = () => (
    <OrgScopedRouteGuard paramName={paramName}>
      <Page {...props} />
    </OrgScopedRouteGuard>
  );

  OrgScopedRoute.displayName = `OrgScopedRoute(${Page.displayName || Page.name || 'Page'})`;

  return OrgScopedRoute;
};
